enum Colors {
    RED= 'RED',
    GREEN='GREEN',
    BLUE= 'BLUE'
}

export default Colors;